import { useState } from 'react';
import type { FieldValues, Path, PathValue, UseFormSetValue } from 'react-hook-form';

/**
 * Manages an optional form field that can be shown or hidden via a toggle.
 * When the field is hidden, its value is cleared so it is not submitted.
 */
export const useOptionalField = <T extends FieldValues>(
    setValue: UseFormSetValue<T>,
    name: Path<T>,
    initialVisible = false
) => {
    const [visible, setVisible] = useState(initialVisible);

    const toggle = () => {
        setVisible(prev => {
            const next = !prev;
            if (!next) {
                setValue(name, '' as PathValue<T, Path<T>>);
            }
            return next;
        });
    };

    return [visible, toggle] as const;
};
